<div class="row">
  <div class="col-6 secondary-details">
    <i class="icon-mat bi bi-clock-history">&nbsp;</i>
    <span>
      {{ 'pickup.pickupList.pickupHistory' | translate }}
    </span>
  </div>

  <div class="col-6 text-end">
    <button
      class="me-1 icon-mat-button"
      (click)="openBookPickup()"
      #tooltip="matTooltip"
      matTooltip="{{ 'pickup.pickupList.bookPickup' | translate }}"
      mat-raised-button>
      <em class="bi bi-bus-front-fill"></em>
    </button>
    <button
      class="me-1 icon-mat-button"
      (click)="onRefresh()"
      #tooltip="matTooltip"
      matTooltip="{{ 'pickup.pickupList.refresh' | translate }}"
      mat-raised-button>
      <em class="bi bi-arrow-clockwise"></em>
    </button>
    <button
      class="me-1 icon-mat-button"
      (click)="openFilterDialog()"
      #tooltip="matTooltip"
      matTooltip="{{ 'pickup.pickupList.filter' | translate }}"
      mat-raised-button>
      <em class="bi bi-funnel"></em>
    </button>
  </div>
  <p *ngIf="environmentConfig.TITLE === 'MYDHL BREAKBULK UAT'" class="warning">
    {{ 'pickup.pickupList.pickupRequestLabel' | translate }}
  </p>
  <div class="row">
    <div class="col-sm-6 ml-2 search-bar-group">
      <input
        matInput
        class="pt-2 input-search"
        [formControl]="searchKeywordFilter"
        placeholder="
        {{ 'pickup.pickupList.searchPickup' | translate }}" />
    </div>
  </div>
</div>

<ng-template #dialogRef let-mydata>
  <h6 style="font-weight: bold">
    {{ 'pickup.pickupList.advancedFilter' | translate }}
  </h6>
  <form [formGroup]="AdvFilterForm" (submit)="applyAdvFilter()">
    <div class="mb-4">
      <label class="col-form-label">
        {{ 'pickup.pickupList.date' | translate }}
        :</label
      >&nbsp;
      <mat-form-field>
        <mat-label>
          {{ 'pickup.pickupList.enterDateRange' | translate }}
        </mat-label>
        <mat-date-range-input [rangePicker]="picker">
          <input
            type="text"
            matStartDate
            placeholder="{{ 'pickup.pickupList.startDate' | translate }}"
            formControlName="startDate"
            readonly />
          <input
            type="text"
            matEndDate
            placeholder="{{ 'pickup.pickupList.endDate' | translate }}"
            formControlName="endDate"
            readonly />
        </mat-date-range-input>
        <mat-hint>
          {{ 'pickup.pickupList.dateLabel' | translate }}
        </mat-hint>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>
    </div>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    <button type="submit" [disabled]="isAdvancedFilterCheck()" class="secondary-btn">
      {{ 'pickup.pickupList.submit' | translate }}
    </button>
    <button class="primary-btn ml-2" mat-dialog-close="close" (click)="closeDialog()">
      {{ 'pickup.pickupList.close' | translate }}
    </button>
  </form>
</ng-template>

<div>
  <div class="col-sm-12 table-container">
    <table
      aria-label="reportList"
      mat-table
      matSort
      matSortActive="created_datetime"
      matSortDirection="desc"
      [dataSource]="pickupDataSource">
      <ng-container matColumnDef="pickupId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'pickup.pickupList.confirmationNumber' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">{{ element.confirmationNumber }}</td>
      </ng-container>
      <ng-container matColumnDef="created_datetime">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'pickup.pickupList.bookingDate' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.bookingDate | date : 'dd/MMM/yyyy hh:mm aa' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="plannedPickupDateAndTime">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'pickup.pickupList.pickupDate' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.reqPickupDate | date : 'dd/MMM/yyyy' }}
        </td>
      </ng-container>
      <ng-container matColumnDef="closeTime">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'pickup.pickupList.pickupWindow' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">{{ element.reqPickupWindow }}</td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'pickup.pickupList.status' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">{{ element.status }}</td>
      </ng-container>
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'pickup.pickupList.action' | translate }}
        </th>
        <td mat-cell *matCellDef="let row">
          <span class="row" disabled="{{ row.status != 'Booked' }}">
            <a
              class="btn bg-transparent col-5"
              [ngClass]="{ disable: row.status != 'Booked' }"
              data-toggle="tooltip"
              [matTooltipDisabled]="row.status != 'Booked'"
              matTooltip="
              {{ 'pickup.pickupList.cancelPickup' | translate }}">
              <i
                class="icon-mat bi bi-bag-x-fill"
                [ngClass]="{ disable: row.status != 'Booked' }"
                (click)="openCancelPickup(row)"></i>
            </a>
          </span>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
    <mat-paginator
      #paginator
      [pageSize]="10"
      [length]="totalData"
      [pageSizeOptions]="pageSizes"
      showFirstLastButtons></mat-paginator>
  </div>
</div>
